<template>
  <div class="page-login flex">
    <div class="swiper-container backgroundfff">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="../assets/img/login_banner_1.png" />
        </div>
        <div class="swiper-slide">
          <img src="../assets/img/login_banner_2.png" />
        </div>
        <div class="swiper-slide">
          <img src="../assets/img/login_banner_3.png" />
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
    <div class="login-content pr">
      <div class="login-body tvc">
        <div class="content">
          <div class="title-scales-power flex flex-cross-top flex-main-center">
            <!-- <span class="title">V2power</span> -->
            <!-- <img src="../assets/img/logo_bg.png" alt=""> -->
          </div>
          <img src="../assets/img/logo-blue.png" alt="" />
          <!-- 登录页 -->
          <div v-show="step == '1'">
            <!-- <p class="tip">{{ $t("m.signIn") }}</p> -->
            <p class="text">{{ $t("m.email") }}</p>
            <el-input v-model="email"></el-input>
            <p class="text">{{ $t("m.password") }}</p>
            <el-input
              v-model="psd"
              type="password"
              @keyup.enter.native="login"
            ></el-input>
            <div class="flex flex-main-justify forget-box">
              <span></span>
              <span class="forget-psd cp" @click="goForgetPsd"
                >{{ $t("m.forgetPsd") }}?</span
              >
            </div>
            <div class="operate-box">
              <el-button type="primary" @click="login">{{
                $t("m.signIn")
              }}</el-button>
            </div>
          </div>
          <!-- 忘记密码验证 -->
          <div v-show="step == '2'">
            <p class="tip">{{ $t("m.verfication") }}</p>
            <p class="text">{{ $t("m.email") }}</p>
            <el-input v-model="verificationEmail"></el-input>
            <p class="text">{{ $t("m.securityCode") }}</p>
            <div class="flex">
              <el-input v-model="verificationCode"></el-input>
              <el-button type="primary" @click="sendCode" class="send-btn">{{
                isSend ? countDown : $t("m.send")
              }}</el-button>
            </div>
            <div class="operate-box">
              <el-button type="primary" @click="goSetNewPsd">{{
                $t("m.nextBtn")
              }}</el-button>
            </div>
            <p class="return-text cp" @click="backLogin">
              {{ $t("m.return") }}
            </p>
          </div>
          <!-- 设置新密码 -->
          <div v-show="step == 3">
            <p class="tip">{{ $t("m.loginNewPsd") }}</p>
            <p class="text">{{ $t("m.loginNewPsd") }}</p>
            <el-input v-model="newPsd" type="password"></el-input>
            <p class="text">{{ $t("m.confirmNewPsd") }}</p>
            <el-input v-model="confirmNewPsd" type="password"></el-input>
            <div class="operate-box">
              <el-button type="primary" @click="setNewPsd">{{
                $t("m.confirmBtn")
              }}</el-button>
            </div>
            <!-- <p class="return-text cp" @click="backForgetPsd">
              {{ $t("m.return") }}
            </p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from "swiper";
export default {
  data() {
    return {
      isSend: false,
      email: "",
      psd: "",
      step: 1,
      verificationEmail: "",
      verificationCode: "",
      countDown: 59,
      countTimer: null,
      newPsd: "",
      confirmNewPsd: "",
      checkedResult: "",
    };
  },
  mounted() {
    this.myswiper();
  },
  methods: {
    setNewPsd() {
      if (!this.newPsd) {
        this.emptyTip(this.$t("m.password"));
      } else if (!this.judgePassword(this.newPsd)) {
        this.$message.warning(this.$t("m.passwordErrorTip"));
      } else if (this.newPsd != this.confirmNewPsd) {
        this.$message({
          type: "error",
          message: this.$t("m.secondPsdDifferentTip"),
        });
      } else {
        this.$http
          .post("/auth/forget/pwd/reset", {
            email: this.verificationEmail,
            pwd: this.newPsd,
            comfirmPwd: this.confirmNewPsd,
            verificationCode: this.checkedResult,
          })
          .then((res) => {
            this.$message({
              type: "success",
              message: this.$t("m.savedTip"),
            });
            this.verificationEmail = "";
            this.newPsd = "";
            this.confirmNewPsd = "";
            this.checkedResult = "";
            this.verificationCode = "";
            this.countDown = 59;
            this.isSend = false;
            this.step = 1;
          });
      }
    },
    backLogin() {
      this.step = 1;
    },
    backForgetPsd() {
      this.step = 2;
      this.newPsd = "";
      this.confirmNewPsd = "";
    },
    goSetNewPsd() {
      if (!this.verificationEmail) {
        this.emptyTip(this.$t("m.email"));
      } else if (!this.judgeEmail(this.verificationEmail)) {
        this.$message({
          type: "error",
          message: this.$t("m.emailErrorTip"),
        });
      } else if (!this.verificationCode) {
        this.emptyTip(this.$t("m.securityCode"));
      } else {
        this.$http
          .post("/auth/forget/pwd/code/check", {
            email: this.verificationEmail,
            verificationCode: this.verificationCode,
          })
          .then((res) => {
            console.log(res, "check result");
            this.checkedResult = res.data;
            this.step = 3;
          });
      }
    },
    sendCode() {
      if (!this.isSend) {
        if (this.judgeEmail(this.verificationEmail)) {
          this.$http
            .get("/auth/forget/pwd/code?email=" + this.verificationEmail)
            .then((res) => {
              console.log(res, "code");
              this.isSend = true;
              this.countDown = 59;
              this.$message.success(this.$t("m.sentTip"));
              this.downCount();
            });
        } else {
          this.$message({
            type: "error",
            message: this.$t("m.emailErrorTip"),
          });
        }
      }
    },
    downCount() {
      this.countTimer = setInterval(() => {
        if (this.countDown == 1) {
          this.isSend = false;
          clearInterval(this.countTimer);
        }
        this.countDown--;
      }, 1000);
    },
    goForgetPsd() {
      this.step = 2;
    },
    myswiper() {
      // eslint-disable-next-line no-new
      new Swiper(".swiper-container", {
        modules: [Navigation, Pagination, Scrollbar, Autoplay],
        pagination: {
          el: ".swiper-pagination", // 换页器与哪个标签关联
          clickable: true, // 分页器是否可以点击
        },
      });
    },
    login() {
      if (!this.email) {
        this.emptyTip(this.$t("m.email"));
      } else if (!this.psd) {
        this.emptyTip(this.$t("m.password"));
      } else {
        this.$http
          .post("/auth/login", {
            username: this.email,
            password: this.psd,
          })
          .then((res) => {
            console.log(res, "res");
            this.$store.commit("updateToken", res.data.access_token);
            sessionStorage.setItem("userName", this.email);
            this.getUserInfo();
          });
      }
    },
    getUserInfo() {
      this.$http.get("/system/user/getInfo").then((res) => {
        console.log(res, "user info");
        this.$store.commit("updateUserInfo", res.user);
        this.REPLACE({
          name: "index",
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../node_modules/swiper/swiper.scss";
@import "../assets/scss/variables.scss";
.page-login {
  .swiper-container {
    width: calc(100% - 4.3rem);
    background-color: rgb(239, 242, 243);
    overflow: hidden;
    position: relative;
    .swiper-pagination {
      position: absolute;
      bottom: 0.2rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      .swiper-pagination-bullet {
        display: inline-block;
        width: 0.12rem;
        height: 0.12rem;
        background: rgba(15, 89, 168, 0.5);
        margin-right: 10px;
        border-radius: 50%;
        &:last-child {
          margin-right: 0;
        }
        &.swiper-pagination-bullet-active {
          background-color: #0f59a8;
        }
      }
    }
    .swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-height: 100%;
        max-width: 100%;
      }
    }
  }
  .login-content {
    width: 4.3rem;
  }
  .login-body {
    width: 4.3rem;
    border-radius: 2px;
    text-align: center;
    .content {
      padding: 0.4rem;
    }
    .title-scales-power {
      .title {
        font-size: 0.36rem;
        font-weight: 600;
        color: #0f59a8;
      }
    }
    .tip {
      color: #333;
      font-size: 0.24rem;
      margin-top: 0.2rem;
      font-weight: 500;
    }
    input {
      background: none;
      border-color: #35383f;
      color: #333;
    }
    .text {
      text-align: left;
      color: #666;
      margin-top: 0.2rem;
      margin-bottom: 0.1rem;
    }
    .forget-box {
      margin-top: 0.1rem;
      color: #0f59a8;
    }
    .operate-box {
      margin-top: 0.4rem;
      button {
        width: 100%;
        padding: 0;
        height: 40px;
        line-height: 40px;
      }
    }
    .send-btn {
      margin-left: 0.2rem;
      width: 0.8rem;
      flex-shrink: 0;
    }
    .return-text {
      color: #0093ff;
      font-size: 0.14rem;
      margin-top: 0.2rem;
    }
  }
}
</style>
